import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useElement from "backend/hooks/elements/useElement";
import KPIReport from "components/reports/KPIReport";
import ToolbarWithButton from "components/toolbars/ToolbarWithButton";
import ExportFileSelectionPopUp from "design/components/popups/ExportFileSelectionPopup";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import React, { useState } from "react";

type Props = {};

const KPIToolbar = (props: Props) => {
  const ctx = useAppContext();
  const { data } = useElement(ctx.elementId);
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [fileType, setFileType] = useState<string | null>();
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelectFile = (type: string) => {
    setFileType(type);
    setAnchorEl(null);
    setIsExporting(true);
  };
  return (
    <>
      <ToolbarWithButton onClick={handleClick}>
        <ToolbarTitle>{data?.name}</ToolbarTitle>
      </ToolbarWithButton>
      {data ? (
        <>
          <ExportFileSelectionPopUp
            onClose={() => {
              setAnchorEl(null);
            }}
            handleClick={handleSelectFile}
            anchorEl={anchorEl}
          />
        </>
      ) : null}

      {isExporting && data && fileType ? (
        <KPIReport
          item={data}
          filetype={fileType!}
          onClose={() => {
            setIsExporting(false);
          }}
        />
      ) : null}
    </>
  );
};

export default KPIToolbar;
